import { sendContact } from '@gik/contact/api/ContactAPI';
import { ContactFormInputNames } from '@gik/contact/enums/ContactFormInputNames';
import { contactFormSchema } from '@gik/contact/formSchemas';
import { translationKeys } from '@gik/contact/i18n/en';
import { useBemCN } from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { translationKeys as commonTranslationKeys } from '@gik/i18n/en/common';
import { Form } from '@gik/ui/Form';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface IContactFormProps {}

const blockName = 'contact-form';

export interface ISendContactFormValues {
  [ContactFormInputNames.Name]: string;
  [ContactFormInputNames.EmailAddress]: string;
  [ContactFormInputNames.Message]: string;
  [ContactFormInputNames.SignUpNewsletter]: boolean;
}

function ContactFormComp(_props: IContactFormProps) {
  const bem = useBemCN(blockName);
  const { t } = useTranslation();

  const [error, setError] = React.useState<boolean>(false);
  const [finished, setFinished] = React.useState<boolean>(false);

  async function onClickSend(values: ISendContactFormValues) {
    if (values) {
      try {
        await sendContact(values);
      } catch (e) {
        setError(true);
      } finally {
        setFinished(true);
      }
    }
  }

  return (
    <section {...bem()}>
      {finished ? (
        <>
          {error ? (
            <p>{t(translationKeys.ContactFormError).toString()}</p>
          ) : (
            <p>{t(translationKeys.ContactFormSent).toString()}</p>
          )}
        </>
      ) : (
        <>
          <h2 {...bem('form-heading')}>{t(translationKeys.FormHeading).toString()}</h2>
          <p {...bem('form-subheading')}>{t(translationKeys.FormSubheading).toString()}</p>

          <Form
            schema={contactFormSchema()}
            initialValues={{
              [ContactFormInputNames.SignUpNewsletter]: true,
            }}
            vertical
            submitButton
            submitButtonText={t(commonTranslationKeys.send)}
            onSubmit={onClickSend}
            id="contact-form"
            restoreAfterUpdate
          />
        </>
      )}
    </section>
  );
}

export const ContactForm = withComponentErrorBoundary(ContactFormComp);
